import { useEffect } from "react";
import { toast } from "sonner";
import { onTtsError, useTts } from "@/lib/elevenVoice";

/**
 * Mount once (in the root layout). Listens for TTS failures anywhere in the
 * app and surfaces a friendly toast with a Retry action that re-runs the
 * last speech request through the authenticated server-fn caller.
 */
export function TtsErrorToast() {
  const { caller } = useTts();
  useEffect(() => {
    return onTtsError((info) => {
      toast.error(info.message, {
        id: "tts-error",
        duration: 8000,
        action: {
          label: "Retry",
          onClick: () => info.retry(caller),
        },
      });
    });
  }, [caller]);
  return null;
}
